import { PrivacyAndCookiesMenu } from "../footer/PrivacyAndCookiesMenu";

export { PrivacyAndCookiesMenu };
